import { useRef, useState } from 'react';

interface PayFortConfigModel {
  PayFortUrl: string;
  creditCardNumber: string;
  creditCardHolder: string;
  expiryMonth: number;
  expiryYear: number;
  serviceCommand: string;
  accessCode: string;
  merchantIdentifier: string;
  merchantReference: string;
  currency: string;
  language: string;
  signature: string;
  returnUrl: string;
  errorCallback?: (errorMessage: string) => void;
}

export const usePayFortTokenization = () => {
  const [isPayFortLoading, setIsPayFortLoading] = useState(false);

  const { current: PayFortTokenizationController } = useRef<AbortController>(
    new AbortController()
  );

  const PayFortTokenization = async (config: PayFortConfigModel) => {
    const {
      PayFortUrl,
      creditCardNumber,
      creditCardHolder,
      expiryMonth,
      expiryYear,
      serviceCommand,
      accessCode,
      merchantIdentifier,
      merchantReference,
      currency,
      language,
      signature,
      returnUrl,
      errorCallback,
    } = config;

    try {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      const raw = JSON.stringify({
        service_command: serviceCommand,
        access_code: accessCode,
        merchant_identifier: merchantIdentifier,
        merchant_reference: merchantReference,
        currency,
        language,
        expiry_date: `${String(expiryYear).slice(-2)}${String(expiryMonth).padStart(
          2,
          '0'
        )}`,
        card_number: creditCardNumber,
        signature,
        card_holder_name: creditCardHolder,
        return_url: returnUrl,
      });

      const requestOptions: RequestInit = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
        signal: PayFortTokenizationController.signal,
      };

      setIsPayFortLoading(true);

      const response = await fetch(
        `${PayFortUrl}/FortAPI/tokenization/tokenize`,
        requestOptions
      );
      const res = await response.json();
      if (!response.ok) {
        errorCallback?.('my_credit_cards.payment_gateway.fail');
      }

      if (res?.status !== '52') {
        errorCallback?.(res.response_message);
        throw new Error(
          `PayFort Tokenization failed with status code ${response.status}`
        );
      }
      return res;
    } catch (error) {
    } finally {
      setIsPayFortLoading(false);
    }
  };

  return {
    isPayFortLoading,
    PayFortTokenizationController,
    PayFortTokenization,
  };
};
